exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".prozorce{left:50%;position:absolute;text-align:center;top:50%;transform:translate(-50%,-50%);padding:20px;border-radius:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./game-ui/css/60-prozorce.css
// module id = 29
// module chunks = 0